import { useQuery } from 'hooks/useQuery'

import { fetchConstants } from 'utils/queries'

import { RemoteConstantsValues } from 'types/remoteConstants'

export const useRemoteConstants = () => {
  return useQuery<RemoteConstantsValues>(['constants'], () => fetchConstants())
}
